export class CompletionBehaviorTemplate {
  name: string | undefined;
  settings: any | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.settings = payload.settings;
    }
  }
}
